import { createContext, useContext } from "react";

import type { UseInteractionsReturn } from "@floating-ui/react";

import type {
  DropdownDirection,
  DropdownProps,
  DropdownValueOrArray,
} from "./Dropdown.types";

export type DropdownContextValue = {
  open: boolean;
  setOpen: (next: boolean, event?: React.SyntheticEvent) => void;
  disabled: boolean;
  direction: DropdownDirection;
  upward: boolean;
  value: DropdownValueOrArray | undefined;
  multiple: boolean;
  /** Trigger dropdowns are action menus rather than selects. */
  menu: boolean;
  closeOnChange: boolean;
  selectOption: (
    event: React.SyntheticEvent<HTMLElement>,
    optionValue: DropdownValueOrArray | undefined,
  ) => void;
  getItemProps: UseInteractionsReturn["getItemProps"];
  rootProps: DropdownProps;
};

const DropdownContext = createContext<DropdownContextValue | null>(null);

export function useDropdownContext(): DropdownContextValue | null {
  return useContext(DropdownContext);
}

export { DropdownContext };
